import PropTypes from 'prop-types';
import { RouterProvider } from 'react-router';
import { HelmetProvider } from 'react-helmet-async';

import './utils/fontAwesome';


const App = ({ router }) => (
  <HelmetProvider>
    <RouterProvider router={router} />
  </HelmetProvider>
);

App.propTypes = {
  router: PropTypes.object.isRequired,
};

export default App;
